export default __webpack_public_path__ + "static/media/11.28f19b4d.jpg";